import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router";
import { GetListOfUserAuditTrailCancelToken } from "../../../services/UserService";
import { IMAGE_URL, TABLE_DATE_FORMAT, TABLE_ROWS_PER_PAGE, TABLE_TIME_FORMAT } from "../../../utils/Constants";
import Str from "../../common/Str";
import { ColorRender } from "./CheckRole";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Swal from "sweetalert2";
import moment from "moment";
import { InitialRender } from "../../common/Helper";
import Hover from "../../common/Hover";
import { RenderAuditTrailActionType } from "../../../utils/CommonGroupingItem";
import axios from "axios";
import { handleTableScroll } from "../../../utils/commonFunction";
import { createCleanFilePath } from "../../../utils/FileDownload";

const AuditTrail = () => {
  const history = useHistory();
  const [search, setSearch] = useState("");

  const [userData, setUserData] = useState([]);

  const [actiontype, setActionType] = useState([]);
  const [searchActionTypeCheck, setSearchActionTypeCheck] = useState({});

  const [month, setMonth] = useState([]);
  const [searchMonthCheck, setSearchMonthCheck] = useState({});

  const [year, setYear] = useState([]);
  const [searchYearCheck, setSearchYearCheck] = useState({});

  const [loading, setloading] = useState(true);

  useEffect(() => {
    handleTableScroll()
  }, [loading])
  useEffect(() => {
    const cancelTokenSources = [];

    const getData = async () => {
      setloading(true);

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const res = await GetListOfUserAuditTrailCancelToken(source.token);
        let tempData = []
        res.data.audit_trail.map(item => {
          tempData.push({
            ...item,
            description: item.description ? JSON.parse(item.description) : {}
          })
        })
        setUserData(tempData);
        if (res.status === 200) {
          setloading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    }

    getData();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, []);

  const sortingDate = (rowA, rowB) => {
    const date1 = new Date(rowA.description.timestamp);
    const date2 = new Date(rowB.description.timestamp);

    if (date2 > date1) {
      return 1;
    } else if (date2 < date1) {
      return -1;
    } else {
      return 0;
    }
  };

  const sortingName = (rowA, rowB) => {
    const name1 = rowA.description.object.definition.New.Firstname.toString();
    const name2 = rowB.description.object.definition.New.Firstname.toString();
    return name1.localeCompare(name2);
  };

  const sortingUser = (rowA, rowB) => {
    const name1 = rowA.description.User.name.trim().toLowerCase();
    const name2 = rowB.description.User.name.trim().toLowerCase();
    return name1.localeCompare(name2);
  };

  const difference = (obj1, obj2) => {
    let keyFound = [];
    Object.keys(obj1).forEach((key) => {
      if (obj1[key] !== obj2[key]) {
        return keyFound.push(key + ":" + obj1[key]);
      }
    });
    return keyFound;
  };

  const columns = useMemo(() => [
    {
      name: "User",
      selector: "user",
      sortable: true,
      sortFunction: sortingUser,
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className="assigned-title-blk name-icon">
              {row.description.User.URL ? <img src={`${!row.description.User.URL.includes("https://myaie.ac") ? IMAGE_URL + "/" : ""}${createCleanFilePath(row.description.User.URL).replaceAll("adminapi.myaie.ac17278/", "").replaceAll("devadminapi.myaie.ac1788/", "")}`} alt="AIE" /> : InitialRender([row.description.User.name, row.description.User.name])}

              <span className={`profile-box-2-status ${row.description.User.status ? row.description.User.status : "Offline"}`}>
                <i className="fas fa-circle"></i>
              </span>
              <Hover firstName={row.description.User.name.split(" ")[0]} lastName={row.description.User.name.split(" ")[1]} photo={`${row.description.User.URL ? createCleanFilePath(row.description.User.URL.replace("https://myaie.ac", "")).replaceAll("adminapi.myaie.ac17278/", "").replaceAll("devadminapi.myaie.ac1788/", ""):""}`} email={row.description.User.mbox} mobile={row.description.User.Mobile} status={""} role={""} right={true} />
            </span>
            <p><b>{row.description.User.name}</b></p>
          </div>
        </div>
      ),
    },
    {
      name: "Action Type",
      cell: (row) => RenderAuditTrailActionType(row.description.verb.Action).html,
    },

    {
      name: "Resource Type",
      cell: (row) => "User",
    },
    {
      name: "Resource Name",
      selector: "Name",
      sortable: true,
      sortFunction: sortingName,
      cell: (row) => {
        if (row.description.verb.Action === "User Deleted") {
          return row.description.object.definition.New.Firstname + " " + row.description.object.definition.New.Lastname;
        } else {
          return (
            <div className="assigned-title-block-new">
              <div className="assigned-title-itm">
                <span className={"assigned-title-blk name-icon " + ColorRender(row.description.object.definition.New?.role_name?.toLowerCase())}>
                  {row.description.User.URL ? <img src={`${!row.description.User.URL.toString().includes("https://myaie.ac") ? IMAGE_URL + "/" : ""}${createCleanFilePath(row.description.User.URL).replaceAll("adminapi.myaie.ac17278/", "").replaceAll("devadminapi.myaie.ac1788/", "")}`} alt="AIE" /> : InitialRender([row.description.object.definition.New.Firstname ? row.description.object.definition.New.Firstname : "N", row.description.object.definition.New.Lastname ? row.description.object.definition.New.Lastname : "A"])}
                  <span className={`profile-box-2-status ${row.description.object.definition.New.Status ? row.description.object.definition.New.Status : "Offline"}`}>
                    <i className="fas fa-circle"></i>
                  </span>
                  <Hover firstName={row.description.object.definition.New.Firstname} lastName={row.description.object.definition.New.Lastname} photo={row.description.object.definition.URL ? `${createCleanFilePath(row.description.object.definition.URL.replaceAll("https://myaie.ac", "")).replaceAll("adminapi.myaie.ac17278/", "").replaceAll("devadminapi.myaie.ac1788/", "")}` : ""} email={row.description.User.mbox} mobile={row.description.User.Mobile} status={row.description.object.definition.New.is_active} right={true} role={row.description.object.definition.New?.role_name} />
                </span>
                <p className="as-text-blue curser" onClick={() => history.push(`/systemAdministration/userManagement/open/${row.description.object.user_id}/aboutYou`)}>
                  {row.description.object.definition.New.Firstname}
                </p>
              </div>
            </div>
          );
        }
      },
    },

    {
      name: "Old Value",
      cell: (row) => {
        const entries = Object.entries(row.description.object.definition?.Old);

        if (row.description.verb.Action === "Created") {
          return "NA";
        } else if (row.description.verb.Action === "Edited") {
          const diff = difference(row.description.object.definition?.Old, row.description.object.definition?.New);
          return diff.length !== 0
            ? <div className="tooltip-custom" title={`${diff.sort().map(entry => entry.toString())}`.split(',').join("\n")}>
              {diff.sort().map((entry, index) => {
                return (index < 2 && <p key={index}>
                  {entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry}
                </p>)
              })}
              {diff.length > 2 ? "..." : null}
            </div>
            : "NA";
        } else {
          return entries.map((entry, index) => (
            <p key={index} title={String(entry[1])}>
              {entry[0]}:{entry[1] ? (entry[1].toString().length > 30 ? entry[1].toString().slice(0, 30) + "..." : entry[1]) : "N/A"}
            </p>
          ));
        }
      },
    },
    {
      name: "New Value",
      cell: (row) => {
        const entries = Object.entries(row.description.object.definition?.New);
        if (row.description.verb.Action === "Edited") {
          const diff = difference(row.description.object.definition?.New, row.description.object.definition?.Old);
          return diff.length !== 0
            ? <div className="tooltip-custom" title={`${diff.sort().map(entry => entry.toString())}`.split(',').join("\n")}>
              {diff.sort().map((entry, index) => {
                return (index < 2 && <p key={index}>
                  {entry.toString().length > 30 ? entry.toString().slice(0, 30) + "..." : entry}
                </p>)
              })}
              {diff.length > 2 ? "..." : null}
            </div>
            : "NA";
        } else if (row.description.verb.Action === "Profile Picture Edited") {
          return (
            <p title={row.description.object.definition?.New?.picture_me}>
              {row.description.object.definition?.New?.picture_me.toString().length > 30
                ? "picture_me:" + row.description.object.definition?.New?.picture_me.toString().slice(0, 30) + "..."
                : row.description.object.definition?.New?.picture_me}
            </p>
          );
        } else {
          return (
            <div className="tooltip-custom" title={`${entries.map(entry => entry[0] + ":" + (entry[1] ? entry[1] : "NA"))}`.split(',').join("\n")}>
              {entries.map((entry, index) => {
                return (index < 2) && (<p key={index} >
                  {entry[0]}:{entry[1] ? (entry[1].toString().length > 30 ? entry[1].toString().slice(0, 30) + "..." : entry[1]) : "N/A"}
                </p>)
              })}
              {entries.length > 2 ? "..." : null}
            </div>
          );
        }
      },
    },
    {
      name: "Date",
      sortable: true,
      selector: "Date",
      sortFunction: sortingDate,
      cell: (row) => {
        let today = new Date().toLocaleDateString();
        return row.description.timestamp ? (
          <>
            <p>{moment(row.description.timestamp).format(TABLE_DATE_FORMAT + ",")}</p>
            <p>{moment(row.description.timestamp).format(TABLE_TIME_FORMAT)}</p>
          </>
        ) : (
          "NA"
        );
      },
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              onClick={() => {
                Swal.fire({ html: `<div className="audit-trial-json"><pre>${JSON.stringify(row.description, undefined, 1)}</pre></div>` });
              }}
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </button>
          </div>
        </div>
      ),
    },
  ]);

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleActionTypeFilter = (e) => {
    const value = e.target.value;
    let arr = actiontype;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setActionType(arr);
    let id = e.target.id;
    setSearchActionTypeCheck({ ...searchActionTypeCheck, [id]: !searchActionTypeCheck[id] });
  };

  const handleMonthFilter = (e) => {
    const value = e.target.value;
    let arr = month;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setMonth(arr);
    let id = e.target.id;
    setSearchMonthCheck({ ...searchMonthCheck, [id]: !searchMonthCheck[id] });
  };

  const handleYearFilter = (e) => {
    const value = e.target.value;
    let arr = year;
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
    } else {
      arr.push(value);
    }
    setYear(arr);
    let id = e.target.id;
    setSearchYearCheck({ ...searchYearCheck, [id]: !searchYearCheck[id] });
  };

  const renderMonthUI = () => {
    let arr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return arr.map((i, index) => {
      return (
        <li key={index}>
          <input type="checkbox" id={index} value={index} onClick={handleMonthFilter} checked={searchMonthCheck[index]} />
          <label htmlFor={index}>
            <span>{i}</span>
          </label>
        </li>
      );
    });
  };

  const renderYearUI = () => {
    let arr = ["2020", "2021", "2022"];
    return arr.map((i, index) => {
      return (
        <li key={index}>
          <input type="checkbox" id={i} value={i} onClick={handleYearFilter} checked={searchYearCheck[i]} />
          <label htmlFor={i}>
            <span>{i}</span>
          </label>
        </li>
      );
    });
  };

  const dataToRender = () => {
    let updatedData = [];
    let allData = userData;
    if (search.length) {

      let tempUser = allData.filter((item) => {
        let includes = item.description.User.name.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let tempName = allData.filter((item) => {
        let includes = item.description.object.definition.New.Firstname.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempUser, ...tempName];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (actiontype.length) {
      let tempAction = updatedData;
      let tempResult = tempAction.filter((item) => {
        const startsWith = actiontype.find((post, index) => {
          if (post.toString() === item.description.verb.Action.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (month.length) {
      let tempMonth = updatedData;
      let tempResult = tempMonth.filter((item) => {
        const startsWith = month.find((post, index) => {
          let monthNumber = new Date(item.description.timestamp).getMonth();
          if (post.toString() === monthNumber.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (year.length) {
      let tempYear = updatedData;
      let tempResult = tempYear.filter((item) => {
        const startsWith = year.find((post, index) => {
          let yearNumber = new Date(item.description.timestamp).getFullYear();
          if (post.toString() === yearNumber.toString()) return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    return updatedData;
  };

  const resetFilter = () => {
    setSearch("");
    setActionType([]);
    setSearchActionTypeCheck({});
    setMonth([]);
    setSearchMonthCheck({});
    setYear([]);
    setSearchYearCheck({});
  };


  const oldValue = (row) => {
    const entries = Object.entries(row.description.object.definition?.Old);
    if (row.description.verb.Action === "Edited") {
      const diff = difference(row.description.object.definition?.Old, row.description.object.definition?.New);
      return diff.length !== 0 ? `${diff.sort()}` : "NA";
    } else {
      return `${entries.map((entry, index) => `${entry[0]}: ${entry[1] ? entry[1] : "N/A"}`)}`
    }
  }

  const NewValue = (row) => {
    const entries = Object.entries(row.description.object.definition?.New);
    if (row.description.verb.Action === "Edited") {
      const diff = difference(row.description.object.definition?.New, row.description.object.definition?.Old);
      return diff.length !== 0 ? `${diff.sort()}` : "NA";
    } else if (row.description.verb.Action === "Profile Picture Edited") {
      return row.description.object.definition?.New?.picture_me.toString().length > 30
        ? "picture_me:" + row.description.object.definition?.New?.picture_me
        : row.description.object.definition?.New?.picture_me;
    } else {
      return `${entries.map((entry, index) => `${entry[0]}: ${entry[1] ? entry[1] : "N/A"}`)}`
    }
  }

  const modifiedData = () => {
    let data = dataToRender();

    data = data?.map((row) =>
    ({
      ...row,
      User: row.description.User.name,
      "Resource Name": row.description.object.definition.New.Firstname + " " + row.description.object.definition.New.Lastname,
      "Resource Type": "User",
      "Action Type": row.description.verb.Action,
      "Old Value": Object.keys(row.description.object.definition.Old).length !== 0 ? oldValue(row) : "NA",
      "New Value": Object.keys(row.description.object.definition.New).length !== 0 ? NewValue(row) : "NA",
      Date: new Date(row.description.timestamp).toLocaleDateString(),
    }))

    return data;
  };

  const exportData = (fileType, fileName) => {
    let data = modifiedData();

    const header = ["User", "Resource Name", "Resource Type", "Action Type", "Old Value", "New Value", "Date"];

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.map((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      // Returning false as downloading of file is already taken care of
      return false;
    }
    if (fileType === "pdf") {
      const compatibleData = data.map((row) => {
        return [row["User"], row["Resource Name"], row["Resource Type"], row["Action Type"], row["Old Value"], row["New Value"], row["Date"]];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        columnStyles: {
          0: {
            columnWidth: 20,
          },
          1: {
            columnWidth: 24,
          },
          2: {
            columnWidth: 24,
          },
          3: {
            columnWidth: 24,
          },
          4: {
            columnWidth: 40,
          },
          5: {
            columnWidth: 40,
          },
          6: {
            columnWidth: 20,
          },
        },
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="custom-table-div filter-search-icon card card-table-custom">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
              <div className="system-administration-table table-responsive">
                  <div className="table-responsive-div">
                    <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                        <div id="assessment-table-main_filter" className="dataTables_filter">
                          <label>
                            <input type="search" className="" placeholder="Search" aria-controls="assessment-table-main" onChange={handleSearchFilter} value={search} />
                          </label>
                          <div className="filter-eff filter-data-btn">
                            <button className="filter-buttons">
                              <i className="fal fa-filter"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                  </div>
                  <div className="filter-button-group">
                      <div className="filter-scroll">
                          <div className={`filter-scroll-inner filter-custom-new`}>
                            <div className="assessment-table-filter">
                              <div className="btn-type-filter dropdown-comman">
                                <div className="dropdown multiselect">
                                  <button
                                    className={`btn btn-default dropdown-toggle ${actiontype.length ? "btn-selected" : ""}`}
                                    type="button"
                                    id="dropdownMenu1"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    title="Action Type"
                                  >
                                    <span>
                                      Action Type <i className="fal fa-angle-down"></i>
                                    </span>
                                  </button>
                                  <form className="dropdown-menu remove-list-style">
                                    <ul aria-labelledby="dropdownMenu1">
                                      <li className="cat cat-skyblue">
                                        <input type="checkbox" id="action1" value="Created" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action1} />
                                        <label htmlFor="action1">
                                          <span className="cat cat-blue">
                                            <i className="fas fa-circle mr-1"></i> Created
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-greenhex">
                                        <input type="checkbox" id="action2" value="Edited" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action2} />
                                        <label htmlFor="action2">
                                          <span className="cat cat-greenhex">
                                            <i className="fas fa-circle mr-1"></i> Edited
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-red">
                                        <input type="checkbox" id="action3" value="Deleted" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action3} />
                                        <label htmlFor="action3">
                                          <span className="cat cat-red">
                                            <i className="fas fa-circle mr-1"></i> Deleted
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-yellowshade">
                                        <input type="checkbox" id="action4" value="Profile Picture Edited" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action4} />
                                        <label htmlFor="action4">
                                          <span className="cat cat-yellowshade">
                                            <i className="fas fa-circle mr-1"></i> Picture Edited
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-green">
                                        <input type="checkbox" id="action5" value="Online" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action5} />
                                        <label htmlFor="action5">
                                          <span className="cat cat-green">
                                            <i className="fas fa-circle mr-1"></i> Online
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-red">
                                        <input type="checkbox" id="action6" value="Offline" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action6} />
                                        <label htmlFor="action6">
                                          <span className="cat cat-red">
                                            <i className="fas fa-circle mr-1"></i> Offline
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-missed">
                                        <input type="checkbox" id="action7" value="Logged Out (AMI Phone)" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action7} />
                                        <label htmlFor="action7">
                                          <span className="cat cat-missed">
                                            <i className="fas fa-circle mr-1"></i>Logged Out (AMI Phone)
                                          </span>
                                        </label>
                                      </li>
                                      <li className="cat cat-purple">
                                        <input type="checkbox" id="action8" value="Logged In (AMI Phone)" onClick={handleActionTypeFilter} checked={searchActionTypeCheck.action8} />
                                        <label htmlFor="action8">
                                          <span className="cat cat-purple">
                                            <i className="fas fa-circle mr-1"></i> Logged In (AMI Phone)
                                          </span>
                                        </label>
                                      </li>
                                    </ul>
                                  </form>
                                </div>
                              </div>
                            </div>

                            <div className="assessment-table-filter">
                              <div className="btn-type-filter dropdown-comman">
                                <div className="dropdown multiselect">
                                  <button
                                    className={`btn btn-default dropdown-toggle ${month.length ? "btn-selected" : ""}`}
                                    type="button"
                                    id="dropdownMenu1"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    title="Month"
                                  >
                                    <span>
                                      Month <i className="fal fa-angle-down"></i>
                                    </span>
                                  </button>
                                  <form className="dropdown-menu remove-list-style">
                                    <ul aria-labelledby="dropdownMenu1">{renderMonthUI()}</ul>
                                  </form>
                                </div>
                              </div>
                            </div>

                            <div className="assessment-table-filter">
                              <div className="btn-type-filter dropdown-comman">
                                <div className="dropdown multiselect">
                                  <button
                                    className={`btn btn-default dropdown-toggle ${year.length ? "btn-selected" : ""}`}
                                    type="button"
                                    id="dropdownMenu1"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    title="Year"
                                  >
                                    <span>
                                      Year <i className="fal fa-angle-down"></i>
                                    </span>
                                  </button>
                                  <form className="dropdown-menu remove-list-style">
                                    <ul aria-labelledby="dropdownMenu1">{renderYearUI()}</ul>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div className="reset-btn-group">
                        <div className="button-reset dropdown-comman">
                          <button className="btn btn-primary" onClick={resetFilter} title="Reset">
                            <i className="fal fa-redo"></i>Reset
                          </button>
                        </div>
                        <div className="files-export-group">
                          <button
                            type="button"
                            className="btn btn-files"
                            onClick={() => {
                              exportData("xlsx", "Users Audit Trail");
                            }}
                            title="Export spreadsheet"
                          >
                            <i className="fal fa-file-excel icon"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-files"
                            onClick={() => {
                              exportData("csv", "Users Audit Trail");
                            }}
                            title="Export CSV"
                          >
                            <i className="fal fa-file-csv icon"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-files"
                            onClick={() => {
                              exportData("pdf", "Users Audit Trail");
                            }}
                            title="Export PDF"
                          >
                            <i className="fal fa-file-pdf icon"></i>
                          </button>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="search-filter-div-right">
              <div className=" filter-search-bar-blk">
              </div>
          </div>
      </div>

        {loading ? <SkeletonTicketList />
          : <DataTable
            data={dataToRender()}
            defaultSortField="Date"
            defaultSortAsc={true}
            columns={columns}
            pagination={true}
            noDataComponent={Str.noRecord}
            paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
          />}

      </div>
    </div>
  );
};

export default AuditTrail;
